import script from "./NewColorsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewColorsModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewColorsModal.vue?vue&type=style&index=0&id=5cf727be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf727be"]])

export default __exports__